import React from "react";
import toast from "react-hot-toast";
import useApi from "../useApi";
import { INote, INotesResponse } from "./index.type";

const useGetAdditionalNotesPage = ({ billingId }: { billingId?: string }) => {
  const [additionalNotes, setAdditionalNotes] = React.useState<INote[]>();

  const { loading: getAllNotesLoading, makeApiCall } = useApi({
    method: "GET",
    url: `/rtm/summary-page/cron/pdf/notes/${billingId}`,
    preAuth: true,
  });

  const getAdditionalNotes = async () => {
    const { response, error } = await makeApiCall<undefined, INotesResponse>();

    if (response?.status === "success") {
      setAdditionalNotes(response.data);
    }

    if (error) {
      toast.error(error.msg);
      setAdditionalNotes(undefined);
    }
  };

  React.useEffect(() => {
    getAdditionalNotes();
  }, []);

  return { getAllNotesLoading, additionalNotes, getAdditionalNotes };
};

export default useGetAdditionalNotesPage;
